import { ReactElement } from 'react';
import { match, NO_ELEMENT } from 'utils';
import { SlidingNavigationBlock } from './Sliding/slidingNavigationBlock';
import { TreeNavigationBlock } from './Tree/treeNavigationBlock';
import { ItemBlock } from './itemBlock';
import { NavigationType } from 'models/NavigationType';
import { NavigationRoot } from 'models/NavigationRoot';
import { NavigationBlock } from 'models/NavigationBlock';
import { SlidingNavigation } from 'models/SlidingNavigation';
import { TreeNavigation } from 'models/TreeNavigation';
import { NavigationItem } from 'models/NavigationItem';

const checkType = (type: NavigationType) => (item: NavigationRoot) => item.type === type;
const isSlidingNavigation = checkType(NavigationType.Sliding);
const isTreeNavigation = checkType(NavigationType.Tree);
const isNavigationItem = checkType(NavigationType.Item);

export const navigationMap = match<NavigationBlock | NavigationRoot, ReactElement | null>()
  .when<SlidingNavigation>(isSlidingNavigation, item => (
    <SlidingNavigationBlock key={`sn-${item.title}`} {...item} />
  ))
  .when<TreeNavigation>(isTreeNavigation, item => (
    <TreeNavigationBlock key={`tn-${item.title}`} {...item} />
  ))
  .when<NavigationItem>(isNavigationItem, item => <ItemBlock key={`i-${item.title}`} {...item} />)
  .or(NO_ELEMENT)
  .toFunc();
